// extracted by mini-css-extract-plugin
export default {"banner":"AnnouncementBanner_banner__17rpq","icon":"AnnouncementBanner_icon__IVxz1","text":"AnnouncementBanner_text__3nqZk","chev":"AnnouncementBanner_chev__dPrlk"};